import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';
import { SettingsPageHeader } from 'components/atoms/settings-page-header';
import { SettingsPageTitleWrapper } from 'components/atoms/settings-page-title-wrapper';
import { FilterBar } from 'components/molecules/filter-bar';
import { Page } from 'components/molecules/page';
import { HeaderWithIconTitle } from 'components/molecules/page/page';
import { SettingsPage } from 'routes/settings/setting-page-layout-style';
const Content = styled(Page.Content)`
  padding: var(--layout-03);
  padding-left: var(--layout-02);
  ${FilterBar} {
    padding: 0;
    margin-bottom: var(--layout-02);
    box-shadow: none;
  }
`;
export const Helium = ({ icon, documentTitle, children })=>{
    return /*#__PURE__*/ _jsxs(SettingsPage, {
        children: [
            /*#__PURE__*/ _jsx(SettingsPageHeader, {
                titleComponent: /*#__PURE__*/ _jsx(SettingsPageTitleWrapper, {
                    children: /*#__PURE__*/ _jsx(HeaderWithIconTitle, {
                        icon: icon,
                        title: documentTitle
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Helmet, {
                children: /*#__PURE__*/ _jsx("title", {
                    children: documentTitle
                })
            }),
            /*#__PURE__*/ _jsx(Content, {
                children: children
            })
        ]
    });
};
